import {
    HIDE_ALERT,
    HIDE_LOADER, INVALID_TOKEN, SET_THEME,
    SHOW_ALERT,
    SHOW_LOADER,
    TOGGLE_FALSE_LOG_IN,
    TOGGLE_TRUE_LOG_IN
} from "./types";

const initialState = {
    theme: 'light',
    invalToken: false,
    loading: false,
    loggedIn: false,
    alertBox: {
        text: null,
        type: null
    }
}

export const appReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_THEME: {
            return {...state, theme: action.payload}
        }
        case INVALID_TOKEN:
            return {...state, invalToken: true}
        case SHOW_LOADER:
            return {...state, loading: true}
        case HIDE_LOADER:
            return {...state, loading: false}
        case SHOW_ALERT:
            return {...state, alertBox: {text: action.payload.text, type: action.payload.type}}
        case HIDE_ALERT:
            return {...state, alertBox: null}
        case TOGGLE_TRUE_LOG_IN:
            return {...state, loggedIn: true}
        case TOGGLE_FALSE_LOG_IN:
            return {...state, loggedIn: false}
        default:
            return state
    }
}